import { initializeApp, type FirebaseApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, type Auth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore, type Firestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions, type Functions } from 'firebase/functions';

/**
 * Firebase client setup.
 *
 * The web config is public by design — it identifies the project, it does not
 * authorise anything. Everything that matters is enforced by security rules and
 * custom claims on the server side.
 */
const firebaseConfig = {
  apiKey: 'AIzaSyDkqoRjV5D6ApAvCWdcVVqor-y_pBNEJJk',
  authDomain: 'trackilero.firebaseapp.com',
  projectId: 'trackilero',
  storageBucket: 'trackilero.firebasestorage.app',
  messagingSenderId: '909514796937',
  appId: '1:909514796937:web:ef16c64944fa13dbe77b58',
  measurementId: 'G-LPLMFHNXJK',
};

/** Functions and Firestore are both pinned to the region the tenants live in. */
export const FUNCTIONS_REGION = 'europe-west1';

export const app: FirebaseApp = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const functions: Functions = getFunctions(app, FUNCTIONS_REGION);

/**
 * Local development points at the emulator, never at production.
 *
 * Driven by an env flag rather than by hostname sniffing, so a preview build
 * served from localhost cannot silently talk to the emulator and a developer
 * cannot silently talk to production.
 */
const useEmulator = import.meta.env.VITE_USE_EMULATOR === 'true';

if (useEmulator) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}
